import * as React from 'react';
import Avatar from '@mui/joy/Avatar';
import Chip from '@mui/joy/Chip';
import Box from '@mui/joy/Box';
import Button from '@mui/joy/Button';
import ButtonGroup from '@mui/joy/ButtonGroup';
import Card from '@mui/joy/Card';
import CardContent from '@mui/joy/CardContent';
import CardOverflow from '@mui/joy/CardOverflow';
import CardActions from '@mui/joy/CardActions';
import IconButton from '@mui/joy/IconButton';
import Typography from '@mui/joy/Typography';
import SvgIcon from '@mui/joy/SvgIcon';
import SettingsRoundedIcon from '@mui/icons-material/SettingsRounded';
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
import Tooltip from '@mui/joy/Tooltip';
import WidgetButtons from '../WidgetButtons';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import SyncProblemRoundedIcon from '@mui/icons-material/SyncProblemRounded';
import CachedRoundedIcon from '@mui/icons-material/CachedRounded';
import { WidgetSyncIcon } from '../WidgetSyncIcon';

export default function CardWidget(props) {
  return (
    <Card
      sx={theme => ({
        width: '100%',
        height: '100%',
        boxShadow: 'md',
        gap: 0,
        '--joy-shadowOpacity': .08,//.18,
        '--joy-shadowChannel': props.error ? '165 24 24'  : theme.shadowChannel,
        '--joy-shadowRing': props.error ? `0 0 ${theme.palette.danger[600]}` :  theme.shadowRing,
        '--joy-shadow-md': 'var(--joy-shadowRing, 0 0 #000),0px 2px 8px -2px rgba(var(--joy-shadowChannel, 21 21 21) / var(--joy-shadowOpacity, 0.08)),0px 6px 12px -2px rgba(var(--joy-shadowChannel, 21 21 21) / var(--joy-shadowOpacity, 0.08))',
      })}
    >
    <CardOverflow sx={theme => ({ backgroundColor: props.error ? theme.palette.danger[200] : theme.palette.background.level1 })}>
        <CardActions sx={{py: 1}}>
            <Typography sx={theme => ({flex: 1, fontWeight: '600', color: props.error ? theme.palette.danger[700] : theme.palette.text.secondary })}>{props.title}</Typography>

            <WidgetButtons
              widget={props.widget}
              updateWidget={props.updateWidget}
              isEditing={props.isEditing}
              onEdit={props.onEdit}
              onRemove={props.onRemove}
            />

            {!props.isEditing && (
            <WidgetSyncIcon {...props} />
            )}
        </CardActions>
      </CardOverflow>
      <CardOverflow
        sx={theme => ({
          overflowY: 'auto',
          scrollbarWidth: 'thin',
          height: '100%',
          backgroundColor: props.error ? theme.palette.danger[50] : null,
          px: props.unpadded && 0,
          ...(props.isEditing && {
            // pointerEvents: 'none',
            // opacity: 0.2,
            '&:after': {
              content: '""',
              position: 'absolute',
              top: 0,
              right: 0,
              bottom: 0,
              left: 0,
              zIndex: 1000,
              cursor: 'move',
              // backgroundColor: 'black',
              // opacity: 0.1,
              // filter: ''
              backdropFilter: 'blur(2px)',
            },
          }),
        })}
      >
        {props.unpadded && (<>{props.children}</>)}
        {!props.unpadded && (
        <CardContent sx={{
          alignItems: 'center',
          textAlign: 'center',
        }}>
          {props.children}
          {/* {props.type} */}
          {/* {JSON.stringify(props.options)} */}
        </CardContent>
        )}
      </CardOverflow>
    </Card>
  );
}
